<template>
  <div
    v-tooltip="tooltipIfDisabled"
    :class="commonEntriesPropertiesCssClasses"
  >
    <date-picker
      :mode="objectModelProperty.datetime_mode"
      :min="minDatetime"
      :max="maxDatetime"
      v-model.sync="localValue"
      :disabled="disabled"
    ></date-picker>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import objectModelEntryPropertiesMixin from "../../mixins/objectModelEntries/objectModelEntryPropertiesMixin";
  import DatePicker from "../datePicker.vue";
  import {DatetimeType} from "../../models/datetimeType";
  import localValueEmissionMixin from "~/mixins/localValueEmissionMixin";
  import organizationMixin from "~/mixins/organizationMixin";

  export default Vue.extend({
    mixins: [localValueEmissionMixin, objectModelEntryPropertiesMixin, organizationMixin],
    components: {
      DatePicker,
    },
    computed: {
      minDatetime(): string | null {
        return this.objectModelProperty.min_datetime_type === DatetimeType.Custom ? this.objectModelProperty.min_datetime : null;
      },
      maxDatetime(): string | null {
        return this.objectModelProperty.max_datetime_type === DatetimeType.Custom ? this.objectModelProperty.max_datetime : null;
      },
    }
  });
</script>